import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";

// Additive to Sentry (see App.tracing.js) - not a replacement.
let newRelicAgent = null;

export function initNewRelic() {
  const applicationID = import.meta.env.NEW_RELIC_APPLICATION_ID;
  if (!applicationID) {
    return;
  }
  try {
    const licenseKey = import.meta.env.NEW_RELIC_BROWSER_LICENSE_KEY;
    const beacon = import.meta.env.NEW_RELIC_BEACON;
    const errorBeacon = import.meta.env.NEW_RELIC_ERROR_BEACON;
    newRelicAgent = new BrowserAgent({
      init: {
        ajax: { deny_list: [beacon, errorBeacon] },
        browser_consent_mode: { enabled: false },
        distributed_tracing: { enabled: true },
        performance: { capture_detail: false, capture_marks: false, capture_measures: true },
        privacy: { cookies_enabled: true },
      },
      loader_config: {
        accountID: Number(import.meta.env.NEW_RELIC_ACCOUNT_ID),
        trustKey: Number(import.meta.env.NEW_RELIC_TRUST_KEY),
        agentID: Number(import.meta.env.NEW_RELIC_AGENT_ID),
        licenseKey,
        applicationID: Number(applicationID),
      },
      info: {
        beacon,
        errorBeacon,
        licenseKey,
        applicationID: Number(applicationID),
        sa: 1,
      },
    });
  } catch (error) {
    console.error("New Relic init - wrong setup", error);
  }
}

export function noticeError(error, customAttributes) {
  try {
    newRelicAgent?.noticeError(error, customAttributes);
  } catch (nrError) {
    console.error("New Relic noticeError - wrong setup", nrError);
  }
}
